export default __webpack_public_path__ + "static/payment-15f9aa5cb74aca0f8645417a478a9102.png";